import {debounce, has, isArray, isEmpty, isNil, omitBy} from 'lodash';

export default {
  data() {
    return {
      loadedQuerySync: false,
      tableQuerySyncDebounce: 500
    }
  },
  watch: {
    queryParams(value) {
      if(!this._updateQueryParamsDebounce || !this.loadedQuerySync) {
        return;
      }

      this._updateQueryParamsDebounce(value);
    }
  },
  created() {
    if(this.$route.query.perPage) {
      this.pagination = {
        ...this.pagination,
        perPage: Number(this.$route.query.perPage),
      }
    }

    if(this.$route.query.currentPage) {
      this.pagination = {
        ...this.pagination,
        currentPage: Number(this.$route.query.currentPage),
      }
    }

    Object.keys(this.$route.query).forEach(key => {
      if(has(this.search, key)) {
        this.search[key] = this.$route.query[key];
      }
    })

    this._updateQueryParamsDebounce = debounce((value) => {
      const updateQuery = value

      if(JSON.stringify(this.$route.query) === JSON.stringify(updateQuery)) {
        return;
      }

      this.$router.replace({
        query: updateQuery,
      })
    }, this.tableQuerySyncDebounce);

    this.$nextTick(() => {
      this.loadedQuerySync = true;
    })
  },
  beforeDestroy() {
    this.loadedQuerySync = false;
    this._updateQueryParamsDebounce.cancel();
  },
  computed: {
    queryParams() {
      const searchFilled = omitBy(this.search, (value) => isNil(value) || value === '' || (isArray(value) && isEmpty(value)));

      return {
        perPage: String(this.pagination.perPage),
        currentPage: String(this.pagination.currentPage),
        ...searchFilled,
      }
    }
  },
}
